<template>
  <div class="columns">
    <div class="column">
      <h5 class="is-size-5 has-text-black">{{ segment.hotel.hotelName }}</h5>

      <div v-if="segment.hotel.address" class="has-text-grey mb-1 is-size-7">
        <div>{{ segment.hotel.address.addressLine1 }}</div>
        
        <span>{{ segment.hotel.address.city }}</span>
        <span v-if="segment.hotel.address.city && segment.hotel.address.state"
          >,</span
        >
        <span> {{ segment.hotel.address.state }} </span>
        <span>{{ segment.hotel.address.postalCode }}</span>
      </div>

      <img width="200" :src="image" style="object-fit:cover;">
      <div class="is-size-7 has-text-grey is-block">
        Confirmation number:

        <span class="has-text-weight-bold has-text-grey-dark">
          {{ segment.confirmationNumber }}</span
        >
      </div>


    </div>

    <div class="column">

      <div class="is-size-6">
        {{ segment.tripLength }} night(s), starting in
        {{ segment.daysUntilStart }} days
      </div>

      <div class="columns mt-2 mb-0">
        <div class="column is-narrow">
          <h5 class="is-size-6 mb-1 has-text-grey">
            <span class="is-size-7 is-block">Check-In:</span>
            {{ segment.startDate.date | formatDate }}
          </h5>
        </div>
        <div class="column is-narrow">
          <h5 class="is-size-6 mb-1 has-text-grey">
            <span class="is-size-7 is-block">Check-Out:</span>
            {{ segment.endDate.date | formatDate }}
          </h5>
        </div>
      </div>

            <div class="is-size-6" v-if="segment.rate">
        Rate:
        {{ segment.rate.amount | formatPriceFromDollars(2) }},
        {{ segment.rate.plan }}
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "HotelSegment",
  components: {},
  props: {
    segment: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      images: Array
    };

  },
  computed: {
    startingIn() {
      if (this.segment.daysUntilStart == 0) {
        return "starts today";
      } else if (this.segment.daysUntilStart > 0) {
        return "starts in " + this.trip.tripSummary.daysUntilStart + " days";
      } else if (this.segment.daysUntilStart < 0) {
        return "Your current trip";
      }
      return null;
    },
    image(){
      if (this.firstimage){
        return this.firstimage.url;
      } 
      else {
        return "/images/defaultHotel.jpg";
      }
      
    },
    firstimage(){
      if (this.images.length > 0){
        return this.images[0];
      } 
      else {
        return null;
      }
    }
  },
  methods: {
    async getImages(hotelcode){
        let raw = {
          'stateful': false,
          'sessionKey': null,
          'normalizeResponse': true,
          'hotelCodes': [this.segment.hotel.propertyCode],
          'infoToReturn':[
            'generalInfo',
            'guestRooms',
            'multimedia'
          ]
        };
        let result = await this.$app.huddleLabsServerCall('amadeus/hotel/description', raw)
        this.images = result.data[0].imagesAndDescriptions.hotel.images;  
        //this.buildImageDict(result.data);

      }
  },
  async mounted(){
    await this.getImages(this.segment.hotel.propertyCode);

  }
};
</script>

<style></style>
